import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Product } from "../../../types/modules/product.type";
import { formatNumber } from "../../../utils/formatNumber";
import PriceText from "../../ui/PriceText";

interface Props {
  products: Product[];
}

const ProductListTable: React.FC<Props> = ({ products }) => {
  const {t} = useTranslation();
  return (
    <div className="overflow-x-auto">
  <table className="w-full border-separate border-spacing-y-5">
    <thead>
      <tr className='text-start text-sm  text-DarkGrey2 font-semibold'>
        <th className="p-3  font-normal">{t("productName")}</th>
            <th className="p-3 font-normal">{t("productNo")}</th>
            <th className="p-3 font-normal">{t("category")}</th>
            <th className="p-3 font-normal">{t("sales")}</th>
            <th className="p-3 font-normal">{t("price")}</th>
            <th className="p-3 font-normal">{t("active")}</th>
      </tr>
    </thead>
    <tbody className="text-sm">
      {products.map((product) => (
        <tr
          key={product.id}
          className="bg-white rounded-[12px]"
          style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
        >
          <td className="p-3 min-w-[250px]">
            <Link  to={`${product.id}`} className="flex items-center gap-3">
            <img
              src={product.images[0]}
              alt={product.languages[0].name}
              className="w-14 h-12 rounded-[12px] object-cover"
            />
            <span className=" text-Black font-black text-[16px]">{product.languages[0].name}</span>
            </Link>
          </td>
          <td className="p-3 min-w-[100px] text-DarkGrey3 font-semibold">{formatNumber(product.productNumber)}</td>
          <td className="p-3 min-w-[100px] text-DarkGrey3 font-semibold">{product.category.languages[0].title}</td>
          <td className="p-3 min-w-[80px] text-DarkGrey3 font-black">{formatNumber(product.sales)}</td>
          <td className="p-3 min-w-[80px] text-DarkGrey3 font-black">
            <div className="flex items-center gap-1 w-[10.67px] h-[11.95px]">
              <img src="/Vector2.png" alt="" />
              <PriceText value={product.basePrice}/>
            </div>
          </td>
          <td className="p-3 min-w-[100px]">
            {product.isActive ? (
              <span className="px-1 py-3 flex items-center justify-center rounded-tl-[20px] rounded-tr-[8px] rounded-br-[20px] rounded-bl-[8px]  w-[64px] h-[32px] text-xs  bg-primaryButton text-white">
                {t("active")}
              </span>
            ) : (
                <span className="px-1 py-3 flex items-center justify-center rounded-tl-[20px] rounded-tr-[8px] rounded-br-[20px] rounded-bl-[8px]  w-[64px] h-[32px] text-xs  bg-DarkGrey3 text-white">
                {t("inactive")}
              </span>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

  );
};

export default ProductListTable;
